import { addHandler } from "@/platform/version_checker";
import { tr } from "@/utils/translations";


addHandler(() => {
    (async () => {
        const [{ default: Flash }] = await Promise.all([
            import("tm:widgets/flash")
        ]);
        const msg = Flash.message(tr("update.available"), "info")
        msg.keep();
    })().catch(window.reportError);
});
